import * as React from 'react'

function CaretDown(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 21.31 12.27"
      {...props}
    >
      <path
        d="M19.63.31a1 1 0 111.42 1.28l-9.69 10.38a1 1 0 01-1.41 0L.26 1.59A1 1 0 111.67.31l9 9.58z"
        fill="#414141"
      />
    </svg>
  )
}

export default CaretDown
